import { toString30pk9tzaqopn as toString } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  toString1pkumu07cwy4m as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var AuthHookDataClass;
function AuthHookData() {
  if (AuthHookDataClass === VOID) {
    class $ {
      constructor(user, authenticated, loading, error, loginWithRedirect, getIdTokenClaims, logout, getAccessTokenSilently) {
        this.j3r_1 = user;
        this.k3r_1 = authenticated;
        this.l3r_1 = loading;
        this.m3r_1 = error;
        this.n3r_1 = loginWithRedirect;
        this.o3r_1 = getIdTokenClaims;
        this.p3r_1 = logout;
        this.q3r_1 = getAccessTokenSilently;
      }
      ef() {
        return this.k3r_1;
      }
      r3r() {
        return this.l3r_1;
      }
      toString() {
        return 'AuthHookData(user=' + toString(this.j3r_1) + ', authenticated=' + this.k3r_1 + ', loading=' + this.l3r_1 + ', error=' + toString(this.m3r_1) + ', loginWithRedirect=' + toString_0(this.n3r_1) + ', getIdTokenClaims=' + toString_0(this.o3r_1) + ', logout=' + toString_0(this.p3r_1) + ', getAccessTokenSilently=' + toString_0(this.q3r_1) + ')';
      }
      hashCode() {
        var result = this.j3r_1 == null ? 0 : hashCode(this.j3r_1);
        result = imul(result, 31) + getBooleanHashCode(this.k3r_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.l3r_1) | 0;
        result = imul(result, 31) + (this.m3r_1 == null ? 0 : hashCode(this.m3r_1)) | 0;
        result = imul(result, 31) + hashCode(this.n3r_1) | 0;
        result = imul(result, 31) + hashCode(this.o3r_1) | 0;
        result = imul(result, 31) + hashCode(this.p3r_1) | 0;
        result = imul(result, 31) + hashCode(this.q3r_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AuthHookData()))
          return false;
        if (!equals(this.j3r_1, other.j3r_1))
          return false;
        if (!(this.k3r_1 === other.k3r_1))
          return false;
        if (!(this.l3r_1 === other.l3r_1))
          return false;
        if (!equals(this.m3r_1, other.m3r_1))
          return false;
        if (!equals(this.n3r_1, other.n3r_1))
          return false;
        if (!equals(this.o3r_1, other.o3r_1))
          return false;
        if (!equals(this.p3r_1, other.p3r_1))
          return false;
        if (!equals(this.q3r_1, other.q3r_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'AuthHookData');
    AuthHookDataClass = $;
  }
  return AuthHookDataClass;
}
//region block: exports
export {
  AuthHookData as AuthHookData2x0lxghdz8ao,
};
//endregion

//# sourceMappingURL=AuthHookData.mjs.map
